import axios from 'axios';
import React, { Fragment, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';

function AllOrdersPage() {
    const [orders, setOrders] = useState([]);
    const API_URL = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const handleOrderData = async () => {
            try {
                const response = await axios.get(`${API_URL}/all-orders`);
                const deliveredOrders = response.data.filter(order => order.status === 'delivered')
                    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)); // Sort by newest first
                setOrders(deliveredOrders);
            } catch (err) {
                toast.error("Failed to fetch orders. Please try again.");
            }
        };

        handleOrderData();
    }, []);

    return (
        <Fragment>
            
            <div className="container-fluid adma">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                        <h2>Delivered Orders</h2>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                        <table className="table table-striped table-hover">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Mobile</th>
                                    <th>Items</th>
                                    <th>Total Price</th>
                                    <th>Address</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {orders.length > 0 ? (
                                    orders.map((item) => (
                                        <tr key={item._id}>
                                            <td>{item.address?.name || "N/A"}</td>
                                            <td>{item.mobile || "N/A"}</td>
                                            <td>
                                                <div className="item-count-hover-container">
                                                    <span className="item-count-trigger text-muted small">
                                                        {item.items?.length || 0}
                                                    </span>
                                                    {item.items && item.items.length > 0 && (
                                                         <div className="item-names-popover shadow-sm" style={{ zIndex: 9999 }}>
                                                            <div className="popover-header fw-bold border-bottom pb-1 mb-2 text-dark" style={{ fontSize: '0.78rem' }}>ORDER ITEMS</div>
                                                            <div className="popover-items-list scrollbar-custom" style={{ maxHeight: '150px', overflowY: 'auto' }}>
                                                                {item.items.map((prod, pIdx) => (
                                                                    <div key={pIdx} className="popover-item d-flex justify-content-between gap-3 text-secondary py-1" style={{ fontSize: '0.75rem', borderBottom: pIdx < item.items.length - 1 ? '1px dashed #f1f5f9' : 'none' }}>
                                                                        <span className="text-start">{prod.name}</span>
                                                                        <span className="text-end fw-bold text-nowrap">x {prod.quantity}</span>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </td>
                                            <td>₹{item.totalAmount || "N/A"}</td>
                                            <td>
                                                {item.address ? (
                                                    `${item.address.house}, ${item.address.area}, ${item.address.landmark}`
                                                ) : "N/A"}
                                            </td>
                                            <td>{item.status}</td>
                                            <td>
                                                <Link to={`/admin/orders-details/${item._id}`} className="action-link">Details</Link>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr><td colSpan="7" className="text-center">No delivered orders found.</td></tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <style>{`
                .item-count-hover-container {
                    position: relative;
                    display: inline-block;
                }
                .item-count-hover-container:hover {
                    z-index: 9999; /* Bring hovered cell stack to front */
                }
                .item-count-trigger {
                    cursor: pointer;
                    border-bottom: 1px dashed #cbd5e1;
                    padding-bottom: 1px;
                    transition: color 0.15s ease;
                }
                .item-count-trigger:hover {
                    color: #ed3237 !important;
                }
                .item-names-popover {
                    display: none;
                    position: absolute;
                    bottom: calc(100% + 8px); /* Position upside */
                    left: 50%;
                    transform: translateX(-50%);
                    background: #ffffff;
                    border: 1px solid #cbd5e1;
                    padding: 10px 14px;
                    z-index: 9999; /* Raise popover above all headers and controls */
                    width: max-content;
                    min-width: 200px;
                    max-width: 280px;
                    text-align: left;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
                }
                /* Downward pointing arrow */
                .item-names-popover::after {
                    content: "";
                    position: absolute;
                    top: 100%;
                    left: 50%;
                    transform: translateX(-50%);
                    border-width: 6px;
                    border-style: solid;
                    border-color: #ffffff transparent transparent transparent;
                }
                .item-names-popover::before {
                    content: "";
                    position: absolute;
                    top: 100%;
                    left: 50%;
                    transform: translateX(-50%);
                    border-width: 7px;
                    border-style: solid;
                    border-color: #cbd5e1 transparent transparent transparent;
                    z-index: -1;
                }
                .item-count-hover-container:hover .item-names-popover {
                    display: block;
                }
            `}</style>
            <ToastContainer />
        </Fragment>
    );
}

export default AllOrdersPage;
